
import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  GetSalesQuotation,
  GetSalesOrder,
  GetOrderHistory,
  GetQuotationDetails,
} from "../../../APIServices/SalesService/OrderHistory/HistoryThunk";
import { FaChevronRight } from "react-icons/fa";
import "./OrderHistory.css";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { toast, Toaster } from "react-hot-toast";
import SearchBar from "../SalesShared/SearchBar/SearchBar";
import OptionToSearch from "../SalesShared/SearchBar/OptionToSearch";
const OrderHistory = () => {
  const storedValue = localStorage.getItem("PAGEData");
  const [value, setValue] = useState(storedValue || "SQ");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, SalesQuotation, SalesOrder,searchHistoryData } = useSelector(
    (state) => state.orderHistory
  );
const [search,SetSearch]=useState(false);
  const [salesQuotations, setSalesQuotations] = useState([]);
  const [salesOrders, setSalesOrders] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const [inProgress, setInProgress] = useState({
    salesQuotation: false,
    salesOrder: false,
    orderHistory: false,
    quotationDetails: false,
    searchHistory:false,
  });
  const fetchData = (tabValue, offsetValue = 0) => {
    localStorage.removeItem("PAGEData");
    setOffset(offsetValue);
    setHasMore(true);
    setSalesQuotations([]);
    setSalesOrders([]);
    if (tabValue === "SQ") {
      setInProgress((prev) => ({ ...prev, salesQuotation: true }));
      dispatch(GetSalesQuotation({ offsetValue }));
    } else if (tabValue === "SO") {
      setInProgress((prev) => ({ ...prev, salesOrder: true }));
      dispatch(GetSalesOrder({ offsetValue }));
    }
  };

  useEffect(() => {
      fetchData(value);

  }, []);
  useEffect(() => {
    const scrollContainer = document.querySelector(".History-div");
    if (!scrollContainer) return;
    const handleContainerScroll = () => {
      if (search) return; 
      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      const isNearBottom = scrollTop + clientHeight + 100 >= scrollHeight;
      const isLoading =
        loading[value === "SQ" ? "SalesQuotation" : "SalesOrder"];
  
      if (isNearBottom && hasMore && !isLoading) {
        const nextOffset = offset + 100;
        setOffset(nextOffset);
        if (value === "SQ") {
          dispatch(GetSalesQuotation({ offsetValue: nextOffset }));
        } else if (value === "SO") {
          dispatch(GetSalesOrder({ offsetValue: nextOffset }));
        }
      }
    };
  
    scrollContainer.addEventListener("scroll", handleContainerScroll);
    return () => {
      scrollContainer.removeEventListener("scroll", handleContainerScroll);
    };
  }, [offset, hasMore, loading, value, search]);
  

  const Checker = () => {
      if (search && inProgress.searchHistory) {
        if(value==='SQ'){
          setSalesQuotations(searchHistoryData);
        }else if(value === "SO"){
          setSalesOrders(searchHistoryData);
        }
      } 
       if (!inProgress.searchHistory&&error?.searchHistoryError) {
        if(value==='SQ'){
        setSalesQuotations(SalesQuotation);
      }else if(value === "SO"){
        setSalesOrders(SalesOrder);
      }
        setInProgress((prev) => ({ ...prev, searchHistory: false }));
    }
      if (inProgress.salesQuotation && error?.SalesQuotationError) {
        setHasMore(false);
        toast.error(error.SalesQuotationError.errorMessage);
        setInProgress((prev) => ({ ...prev, salesQuotation: false }));
      } else if (!search&&inProgress.salesQuotation && SalesQuotation) {
        if (offset === 0) {
          setSalesQuotations(SalesQuotation);
        } else {
          setSalesQuotations((prev) => [...prev, ...SalesQuotation]);
        }
      }
  
      if (inProgress.salesOrder && error?.SalesOrderError) {
        setHasMore(false);
        toast.error(error.SalesOrderError.errorMessage);
        setInProgress((prev) => ({ ...prev, salesOrder: false }));
      } else if (!search&&inProgress.salesOrder && SalesOrder) {
        if (offset === 0) {
          setSalesOrders(SalesOrder);
        } else {
          setSalesOrders((prev) => [...prev, ...SalesOrder]);
        }
      }
    
    
    if (inProgress.quotationDetails && error?.QuotationDetailsError) {
      toast.error(error.QuotationDetailsError.errorMessage);
      setInProgress((prev) => ({ ...prev, quotationDetails: false }));
    }
  
    if (inProgress.orderHistory && error?.OrderHistoryError) {
      toast.error(error.OrderHistoryError.errorMessage);
      setInProgress((prev) => ({ ...prev, orderHistory: false }));
    }
  };
  
  useEffect(() => {
    Checker();
  }, [error, inProgress, SalesQuotation, SalesOrder,searchHistoryData,search]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    fetchData(newValue);
  };

  // Navigation handlers
  const handleQuotationClick = (item) => {
    localStorage.setItem("PAGEData", value);
    sessionStorage.setItem("DocEntry", item.docEntry);
    setInProgress((prev) => ({ ...prev, quotationDetails: true }));
    dispatch(
      GetQuotationDetails({ docEntry: item.docEntry, DocType: "Quotation" })
    ).then(() => {
      if (!error.QuotationDetailsError) {
        navigate("/sales/SOHistory");
      }
    });
  };

  const handleOrderClick = (item) => {
    localStorage.setItem("PAGEData", value);
    sessionStorage.setItem("DocEntry", item.docEntry);
    setInProgress((prev) => ({ ...prev, orderHistory: true }));
    dispatch(
      GetQuotationDetails({ docEntry: item.docEntry, DocType: "Order" })
    ).then(() => {
      if (!error.OrderHistoryError) {
        navigate("/sales/SOHistory");
      }
    });
  };

  // Renderers
  const renderQuotationData = () => {
    // const items = search ? searchData : salesQuotations;
  
    if (!salesQuotations || salesQuotations.length === 0) {
      return (
        <div className="no-orders-container">
          <p className="no-orders-message">No Quotations found.</p>
        </div>
      );
    }
  
    return salesQuotations.map((item) => (
      <div
        key={item.docEntry}
        className="HistoryItem"
        onClick={() => handleQuotationClick(item)}
      >
        <div className="HistoryLeft">
          <p>Order No: {item.order_No}</p>
          <p className="itemname">{item.customer_Name}</p>
          <p>{item.order_Date}</p>
        </div>
        <div className="HistoryRight">
          <p
            className={`status-badge ${
              item.status === "Open" ? "close" : "open"
            }`}
          >
            {item.status === "Open" ? "Pending" : "Approved"}
          </p>
          <p className="order-value">
            Rs:{Number(item.order_Value).toLocaleString("en-IN")}
          </p>
        </div>
        <div className="IconRight">
          <FaChevronRight size={14} />
        </div>
      </div>
    ));
  };
  
  const renderOrderData = () => {
    // const items = search ? searchData : salesOrders;
  // console.log("items",items);
  
    if (!salesOrders || salesOrders.length === 0) {
      return (
        <div className="no-orders-container">
          <p className="no-orders-message">No Orders found.</p>
        </div>
      );
    }
  
    return salesOrders.map((item) => {
      const orderValue = Number(item?.order_Value || 0).toLocaleString("en-IN");
      return (
        <div
          key={item?.docEntry}
          className="HistoryItem"
          onClick={() => handleOrderClick(item)}
        >
          <div className="HistoryLeft">
            <p>Order No: {item?.order_No}</p>
            <p className="itemname">{item?.customer_Name}</p>
            <p>{item.order_Date}</p>
          </div>
          <div className="HistoryRight">
            <p className={`status-badge ${item?.status === "Open" ? "open" : "close"}`}>
              {item?.status}
            </p>
            <p className="order-value">Rs: {orderValue}</p>
          </div>
          <div className="IconRight">
            <FaChevronRight size={14} />
          </div>
        </div>
      );
    });
  };
  
  return (
    <>
      <section style={{ width: "100%" }}>
        <Tabs value={value} onChange={handleChange} className="custom-tabs">
          <Tab value="SQ" label="QUOTATIONS" />
          <Tab value="SO" label="ORDERS" />
        </Tabs>
        <div className="d-flex justify-content-center mt-2">
        <OptionToSearch 
        tabValue={value}  
        setInProgress={setInProgress}
         SetSearch={SetSearch}
        />
        </div>
        <section className="History-div">
          {value === "SQ" ? renderQuotationData() : renderOrderData()}

          {((loading.SalesQuotation || loading.SalesOrder ) && offset > 0)||loading.searchHistoryData && (
            <div className="loader-sales">
              <HashLoader color="#ed1c24" />
            </div>
          )}
        </section>
      </section>

      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
    </>
  );
};

export default OrderHistory;
